import React from "react";
import styled from "styled-components";
import Lottie from "react-lottie-player";

import animation from "../images/click_me_lottie.json";

const WrapperStyled = styled.div`

`;

const ClickOnMeLottie = ({ height = 150, width = 150 }) => {
    return (
        <WrapperStyled
            className="clickme-lottie"
        >
            <Lottie
                loop
                animationData={ animation }
                play
                style={ { width: width, height: height, margin: "auto" } }
            />
        </WrapperStyled>
    );
};

export default ClickOnMeLottie;
